import { defineMessages } from "react-intl";

export const messages = defineMessages({
  assignVariantDialogHeader: {
    id: "juxCV3",
    defaultMessage: "Assign product",
    description: "dialog header",
  },
  assignProductDialogButton: {
    id: "Nv/toB",
    defaultMessage: "Assign and save",
    description: "button",
  },
  assignProductDialogContent: {
    id: "un+VWt",
    defaultMessage: "Search products",
  },
  assignProductDialogSearch: {
    id: "SHm7ee",
    defaultMessage: "Search by product name, attribute, product type etc...",
  },
  noProductsFound: {
    id: "wWELJW",
    defaultMessage: "No products found",
    description: "search results",
  },
});
